/* ──────────────────────────────────────────────────────────────────────────
   denim-addon-cart.js — Add-on Options のカート連動削除
   ──────────────────────────────────────────────────────────────────────────
   メイン商品（custom jeans）が削除された時、_main_line_item_key property で
   リンクされた add-on line item も自動削除する。
   cart-remove-button のクリックを capture フェーズで先取りし、リンクが
   あれば /cart/update.js で一括削除に振り替える。リンクが無ければ何もせず
   既存の cart-items.updateQuantity に流す。 */

(function () {
  if (typeof fetch !== 'function') return;

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('cart-remove-button');
      if (!btn) return;

      var cartItems = btn.closest('cart-items') || btn.closest('cart-drawer-items');
      if (!cartItems) return;

      var lineIdx = parseInt(btn.dataset.index, 10);
      if (!lineIdx) return;

      /* 同期的に処理しないと既定の click ハンドラが先に走ってしまうため、
         /cart.js を呼ばずに済む高速パスを先に試す。
         同じ cart-items 内に _main_line_item_key を含む item があるかは
         事前にはわからないので、常に /cart.js を見る方針にする。ただし
         クリック時点で preventDefault + stopImmediatePropagation して
         既定処理を確実に止めてから async fetch を走らせる。 */

      e.preventDefault();
      e.stopImmediatePropagation();

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var target = cart.items && cart.items[lineIdx - 1];
          if (!target || !target.key) {
            /* 取得失敗時は通常削除にフォールバック */
            cartItems.updateQuantity(lineIdx, 0, e);
            return;
          }

          var linkedKeys = [];
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (it.properties && it.properties._main_line_item_key === target.key) {
              linkedKeys.push(it.key);
            }
          }

          if (!linkedKeys.length) {
            /* リンクなし: 既定の単発削除と同じ挙動 */
            cartItems.updateQuantity(lineIdx, 0, e);
            return;
          }

          batchRemove(cartItems, target.key, linkedKeys);
        })
        .catch(function (err) {
          console.error('[denim-addon-cart] /cart.js fetch failed, falling back:', err);
          cartItems.updateQuantity(lineIdx, 0, e);
        });
    },
    true /* capture phase で既定処理より先に走らせる */
  );

  function batchRemove(cartItems, mainKey, linkedKeys) {
    var updates = {};
    updates[mainKey] = 0;
    linkedKeys.forEach(function (k) { updates[k] = 0; });

    var sectionsToRender = [];
    if (typeof cartItems.getSectionsToRender === 'function') {
      sectionsToRender = cartItems.getSectionsToRender();
    }
    var sections = sectionsToRender.map(function (s) { return s.section; });

    /* ローディング表示（updateQuantity が使うメソッドを再利用） */
    if (typeof cartItems.enableLoading === 'function') {
      try { cartItems.enableLoading(); } catch (_) { /* line 引数なしだと一部処理は no-op */ }
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsedState) {
        var cartDrawerWrapper = document.querySelector('cart-drawer');
        var cartFooter = document.getElementById('main-cart-footer');

        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        sectionsToRender.forEach(function (section) {
          var host = document.getElementById(section.id);
          if (!host) return;
          var elementToReplace = host.querySelector(section.selector) || host;
          var sectionHtml = parsedState.sections && parsedState.sections[section.section];
          if (!sectionHtml) return;
          var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector(section.selector);
          if (parsed) elementToReplace.innerHTML = parsed.innerHTML;
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }
      })
      .catch(function (err) {
        console.error('[denim-addon-cart] batch remove failed:', err);
        var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings && window.cartStrings.error) {
          errors.textContent = window.cartStrings.error;
        }
      })
      .finally(function () {
        if (typeof cartItems.disableLoading === 'function') {
          try { cartItems.disableLoading(); } catch (_) { /* no-op */ }
        }
      });
  }
})();
